document.addEventListener('DOMContentLoaded', () => {

  const popup = document.querySelector('[data-cryo-popup]');

  if (!popup) return;

  /* ======================== 
     GLOBAL OPEN FUNCTION
  ========================= */

  window.openCryoPopup = function() {

    popup.style.display = 'flex';
    popup.classList.add('active');

    document.body.style.overflow = 'hidden';

  };

  /* =========================
     GLOBAL CLOSE FUNCTION
  ========================= */

window.closeCryoPopup = function() {

  popup.style.display = 'none';
  popup.classList.remove('active');

  document.body.style.overflow = '';

  /* =========================
     RESET AGREEMENT CHECKBOX
  ========================= */

  if (agreementCheckbox) {

    agreementCheckbox.checked = false;

  }

  /* =========================
     DISABLE BUTTON AGAIN
  ========================= */

  if (primaryButton) {

    primaryButton.disabled = true;

    primaryButton.classList.add(
      'disabled'
    );

  }

};

  /* =========================
     OPEN VIA DATA ATTRIBUTE
  ========================= */

//  document.addEventListener('click', function(event) {

//   const trigger = event.target.closest(
//     '[data-open-cryo-popup]'
//   );
//   if (!trigger) return;

//    const countryCode = (
//     Shopify.country || ''
//   ).toUpperCase();

//   /*
//     OPEN ONLY FOR US / GB
//   */

//   if (
//     countryCode === 'US' ||
//     countryCode === 'GB'
//   ) {

//     event.preventDefault();

//     openCryoPopup();

//   }


// });

/* =========================
   OPEN VIA DATA ATTRIBUTE
========================= */

document.addEventListener('click', function(event) {

  const trigger = event.target.closest(
    '[data-open-cryo-popup]'
  );

  if (!trigger) return;

  const countryCode = (
    Shopify.country || ''
  ).toUpperCase();

  if (
  countryCode !== 'US' &&
  countryCode !== 'GB'
) {
  return;
}

  /*
    OPEN ONLY FOR US / GB
  */

  if (
    countryCode === 'US' ||
    countryCode === 'GB'
    
  ) {

    event.preventDefault();

    // SAVE SOURCE
    // window.__cryoSource =
    //   trigger.dataset.upgradeVariantId
    //     ? 'accordion'
    //     : 'main-product';

    // // SAVE VARIANT ID
    // window.__cryoUpgradeVariantId =
    //   trigger.dataset.upgradeVariantId || null;

    // // SAVE BUTTON
    // window.__selectedUpgradeButton = trigger;


     if (trigger.dataset.variantId) {

      // Best Products
      window.__cryoSource = 'best-products';
      window.__bestProductVariantId =
        trigger.dataset.variantId;

    } else if (trigger.dataset.upgradeVariantId) {

      // Accordion
      window.__cryoSource = 'accordion';
      window.__cryoUpgradeVariantId =
        trigger.dataset.upgradeVariantId;

    } else {

      // Main Product
      window.__cryoSource = 'main-product';

    }

    openCryoPopup();

  }

});

  /* =========================
     CLOSE BUTTONS
  ========================= */

  popup.querySelectorAll('[data-cryo-close]').forEach((button) => {

    button.addEventListener('click', closeCryoPopup);

  });

  /* =========================
     OUTSIDE CLICK CLOSE
  ========================= */

  popup.addEventListener('click', function(event) {

    if (event.target === popup) {

      closeCryoPopup();

    }

  });

  /* =========================
     ESC KEY CLOSE
  ========================= */

  document.addEventListener('keydown', function(event) {

    if (event.key === 'Escape') {

      closeCryoPopup();

    }

  });

//Agreement terms
  const agreementCheckbox = popup.querySelector(
  '.cryo-checkbox-wrap input[type="checkbox"]'
);

const primaryButton = popup.querySelector('[data-cryo-add]');

if (agreementCheckbox && primaryButton) {

  // disable initially
  primaryButton.disabled = true;
  primaryButton.classList.add('disabled');

  agreementCheckbox.addEventListener('change', function () {

    primaryButton.disabled = !this.checked;

    primaryButton.classList.toggle(
      'disabled',
      !this.checked
    );

  });

}


  //add button logic

  document.addEventListener('click', async function(event) {

  const addButton = event.target.closest('[data-cryo-add]');

  if (!addButton) return;
  showLoader();

  const productAddonVariantId = window.__cryoUpgradeVariantId; 
  const bestProductVariantId = window.__bestProductVariantId;
  const cryoSource = window.__cryoSource;
  event.preventDefault();

  let variantId = '';
  let quantity = 1;
  let sku = '';

  const main = window.SapyenCart.get("main");

window.SapyenCart.update("main", {
  properties: {
    _cryo: true
  }
});

await window.SapyenCartApi.addSapyenCartToShopify();

await window.SapyenCartApi.openCartDrawer();



window.SapyenCart.log();

  if(cryoSource == 'accordion' && productAddonVariantId){
     variantId = productAddonVariantId;
     const response = await fetch(`/variants/${variantId}.js`);
     const variant = await response.json();
     sku = variant?.sku?.toLowerCase();
  } else if(cryoSource=='best-products' &&  bestProductVariantId){
    variantId = bestProductVariantId;
     const response = await fetch(`/variants/${variantId}.js`);
     const variant = await response.json();
     sku = variant?.sku?.toLowerCase();
  } else{

  const productForm = document.querySelector(
    'form[action="/cart/add"]'
  );


   if (!productForm) return;

  // Submit original Shopify form
    const formData = new FormData(productForm);

    variantId = formData.get('id');
    quantity = formData.get('quantity') || 1;


    const response = await fetch(`/variants/${variantId}.js`);
    const variant = await response.json();

     sku = variant?.sku?.toLowerCase();

}

/* =========================
   ADD PRODUCT WITHOUT REDIRECT
========================= */

// await fetch('/cart/add.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify({
//     items: [
//       {
//         id: Number(variantId),
//         quantity: Number(quantity)
//       }
//     ]
//   })
// });





  

  try {

    addButton.disabled = true;

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    /* =========================
       MAP CART ITEMS
    ========================= */
    

   const cartItems = cart.items.map((item, index) => ({
  id: item.id,
  qty: item.quantity,
  sku: item.sku?.toLowerCase(),
}));

const cryo_handle = 'upgrade-add-sperm-freezing';
const cryo_response = await fetch(`/products/${cryo_handle}.js`);
const cryo_product = await cryo_response.json();
const cryo_id = cryo_product?.variants[0].id;
const cryo_sku = cryo_product?.variants[0].sku?.toLowerCase();

    const response = await fetch('https://api.sapyen.co/api/payments/create-checkout-session', {
      method: 'POST',
      headers: {
              'Content-Type': 'application/json',
          'x-api-key': '019df253-e564-7c88-9be6-786af0800aa6' 
              //  'x-api-key':'super_secret_key',
            },
               body: JSON.stringify({
              "cart":[...cartItems],
    "cryo":[
        {"id":variantId, "qty":quantity, "sku": sku},
        {"id":cryo_id , "qty":1 , "sku":cryo_sku}
    ],
    "currency":cart?.currency || 'usd'
            })
      // headers: {
      //   'Content-Type': 'application/json',
      //   "x-api-key":"019df253-e564-7c88-9be6-786af0800aa6",
      // },
      // body: JSON.stringify({
      //   items: [
      //     ...cartItems,

      //   ],
      //   upgradeCryo: true,
      //   currency: cart?.currency || 'usd'
      // })
    });

    const data = await response.json();
    // // Close popup
    closeCryoPopup();

    // Continue existing flow
    // window.location.href = data?.checkout?.url;

  } catch (error) {

    console.error('Error adding cryo item:', error);

  } finally {
    addButton.disabled = false;
    hideLoader();
  }

});

  //Skip button flow:

  document.addEventListener('click',async function(event) {

  const skipButton = event.target.closest('[data-cryo-skip]');

  if (!skipButton) return;


  event.preventDefault();
  event.stopPropagation();

  const main = window.SapyenCart.get("main");

if (main) {
  window.SapyenCart.update("main", {
    properties: {
      ...(main.properties || {}),
      _cryo: false
    }
  });

  await window.SapyenCartApi.addSapyenCartToShopify();
  await window.SapyenCartApi.openCartDrawer();
}
  

  const productAddonVariantId = window.__cryoUpgradeVariantId; 
  const bestProductVariantId = window.__bestProductVariantId;
  const cryoSource = window.__cryoSource;

if (
  cryoSource === 'accordion' &&
  productAddonVariantId
) {

//   await fetch('/cart/add.js', {

//     method: 'POST',

//     headers: {
//       'Content-Type': 'application/json'
//     },

//     body: JSON.stringify({

//       items: [
//         {
//           id: Number(productAddonVariantId),
//           quantity: 1,
//         }
//       ]

//     })

//   });
// window.location.assign('/cart');

const main = window.SapyenCart.get("main");
 

  if (main) {

    // Replace only the variant with the Best Product variant
    // Keep all existing subscription properties
    window.SapyenCart.update("main", {
      variantId: Number(productAddonVariantId), // Use "id" instead if that's what your cart uses
      quantity: 1, // Shopify line item quantity
      properties: {
        ...(main.properties || {}),
        _cryo: false // Change to true in the Add Cryo flow
      }
    });

    // Sync updated cart to Shopify
    await window.SapyenCartApi.addSapyenCartToShopify();
    await window.SapyenCartApi.openCartDrawer();
  }

// const response = await fetch('/cart/add.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json',
//     Accept: 'application/json'
//   },
//   body: JSON.stringify({
//     items: [{
//            id: Number(productAddonVariantId),
//           quantity: 1,
//           properties: {
//             ...(main?.properties || {}),
//             cryo: false // use true in the Add flow
//           }
//         }
//     ]
//   })
// });

// Get updated drawer HTML
const sections = await fetch(
  '/?sections=cart-drawer,cart-icon-bubble'
).then(res => res.json());

const cartDrawer = document.querySelector('cart-drawer');

// cartDrawer.renderContents({
//   id: Number(productAddonVariantId),
//   sections
// });

closeCryoPopup();

}else if(cryoSource === 'best-products' &&
  bestProductVariantId) {

  const main = window.SapyenCart.get("main");

  if (main) {

    // Replace only the variant with the Best Product variant
    // Keep all existing subscription properties
    window.SapyenCart.update("main", {
      id: Number(bestProductVariantId), // Use "id" instead if that's what your cart uses
      quantity: 1, // Shopify line item quantity
      properties: {
        ...(main.properties || {}),
        _cryo: false // Change to true in the Add Cryo flow
      }
    });

    // Sync updated cart to Shopify
    await window.SapyenCartApi.addSapyenCartToShopify();
    await window.SapyenCartApi.openCartDrawer();
  }
  // Clear cart if you want checkout to contain ONLY this product
  // await fetch('/cart/clear.js', {
  //   method: 'POST'
  // });

  // await fetch('/cart/add.js', {
  //   method: 'POST',
  //   headers: {
  //     'Content-Type': 'application/json'
  //   },
  //   body: JSON.stringify({
  //     items: [
  //       {
  //          id: Number(bestProductVariantId),
  //         quantity: 1,
  //         properties: {
  //           ...(main?.properties || {}),
  //           cryo: false // use true in the Add flow
  //         }
  //       }
  //     ]
  //   })
  // });

  // window.location.assign('/checkout');
  }


else {

  // Find original product form
  const productForm = document.querySelector(
    'form[action="/cart/add"]'
  );

  if (!productForm) return;

  // Submit original Shopify form
  // productForm.submit();

}

  
  closeCryoPopup();

});

});